export const TAGLINE_DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'landing-tagline'
export const SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'lp-text'
export const SEO_TAGS_DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'tags-lp-title'
